import { render, staticRenderFns } from "./StoryThumbnail.vue?vue&type=template&id=1b8b9710&"
import script from "./StoryThumbnail.vue?vue&type=script&lang=js&"
export * from "./StoryThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./StoryThumbnail.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/stories/StoryThumbnail.vue
// module id = 890
// module chunks = 0